import { search } from "fast-fuzzy";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ArrowIcon } from "../../Assets/assets";
import { NoResultsFallback } from "../../Components/FallBacks/FallBacks";
import SearchBox from "../../Components/SearchBox/SearchBox";
import { getAllEmployees } from "../../Services/database";
import { isValidArray } from "../../Services/validators";

export default function EmployeeSearch(props) {
  const [searchKey, setSearchKey] = useState("");
  const [employees, setEmployees] = useState(null);
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  useEffect(() => {
    const fetchEmployees = async () => {
      const data = await getAllEmployees();
      setEmployees(data);
    };

    fetchEmployees();

    // eslint-disable-next-line
  }, []);

  const results = useMemo(() => {
    if (isValidArray(employees)) {
      if (!searchKey) {
        return employees;
      }
      return search(searchKey, employees, {
        keySelector: (item) => `${item.phoneNumber} ${item.name}`,
        threshold: 0.7
      });
    }
  }, [searchKey, employees]);

  return (
    <div className="inherit-parent-height inherit-parent-width overflow-hidden">
      <div className="display-flex padding-top-large padding-left-large padding-right-large flex-direction-column">
        <div className="">Capture Reference Image</div>
        <div className=" font-size-small padding-bottom-default">
          Search and capture an employee’s reference photo
        </div>
      </div>
      <>
        <SearchBox
          searchKey={searchKey}
          setSearchKey={setSearchKey}
          data-cy={
            searchKey?.length > 0 ? "search-clear-button" : "search-button"
          }
          placeholder="Search by Phone Number or Name"
        />

        <div className=" inherit-parent-width remaining-body-height_-229px flex-justify-content-center ">
          <div className="inherit-parent-height inherit-parent-width max-width-767px overflow-x-scroll hide-scrollbar flex-justify-content-center">
            {isValidArray(employees) && isValidArray(results) && (
              <div className="inherit-parent-width inherit-parent-height">
                <div
                  className="padding-left-large padding-right-large padding-bottom-large inherit-parent-width inherit-parent-height"
                  data-cy="locations-list"
                >
                  {results.map((data, index) => (
                    <div className="inherit-parent-width" key={index}>
                      <Card
                        onClick={() => {
                          props.setSelectedEmployee(data);
                          if (type === "notMatch") {
                            props.navigate(
                              "/faceIdentification/uploadReference?type=notMatch"
                            );
                          } else {
                            props.navigate(
                              "/faceIdentification/uploadReference"
                            );
                          }
                        }}
                        index={index}
                        data={data}
                        loading={false}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {employees !== null &&
              (!isValidArray(employees) || !isValidArray(results)) && (
                <NoResultsFallback
                  type="EMPLOYEE"
                  resetOnClick={() => {
                    setSearchKey(null);
                  }}
                />
              )}

            {employees === null && <Suspense />}
          </div>
        </div>
      </>
    </div>
  );
}

const Card = (props) => {
  return (
    <div
      onClick={props.onClick}
      className="display-flex inherit-parent-width padding-bottom-large"
      data-cy={`location-card-${props.data.documentId}`}
    >
      <div className="inherit-parent-width display-flex flex-justify-content-space-between">
        <div className=" parent-width_-68px">
          {!props.loading ? (
            <>
              <div className="font-size-medium padding-bottom-small inherit-parent-width text-overflow-ellipsis">
                {props.data.phoneNumber}
              </div>
              <div className="font-size-small">{props.data.name}</div>
            </>
          ) : (
            <div className="inherit-parent-width">
              <div className="shimmer padding-large border-radius-default inherit-parent-width" />
            </div>
          )}
        </div>
        <div className=" display-flex flex-align-items-center ">
          <div className=" display-flex flex-align-items-center ">
            <ArrowIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

const Suspense = () => {
  return (
    <div className="inherit-parent-width padding-top-large">
      {[...Array(7)].map((_data, index) => (
        <div className="inherit-parent-width" key={index}>
          <div className="shimmer padding-larger inherit-parent-width" />
        </div>
      ))}
    </div>
  );
};
